import React, { useState, useEffect } from 'react';

import { IComponentSelect } from '../../component.d';
import { RenderRequired } from './Form';
import moment from 'moment';

const AllForFormSelect = function(props: IComponentSelect) {
  const {
    field,
    align,
    width,
    onChange,
    required,
    label,
    select,
    type
  } = props;

  const [data, setData] = useState('');

  return (
    <div className="all-for-select">
      <div
        className="weui-cells__group weui-cells__group_form"
        style={{ width: `${width}%` }}
      >
        <div className="weui-cells">
          <div
            className="weui-cell weui-cell_active weui-cell_access"
            onClick={() => {
              window.weui!.picker(
                select.map((it: string, index: number) => {
                  return {
                    value: it,
                    label: it
                  };
                }),
                {
                  onChange: (result: any) => {
                    // console.log(`change`, result);
                  },
                  onConfirm: (result: any) => {
                    let target = result[0].value;
                    setData(target);
                    onChange(type, field, target);
                  },
                  title: field
                }
              );
            }}
          >
            <div className="weui-cell__bd">
              {field} {RenderRequired(required)}
            </div>
            <div className="weui-cell__ft">{data}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllForFormSelect;
